'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import PayhawkSolutionImg from '@public/images/payhawk-case-study/payhawk-solution.png'
import PlaceHolder from '@public/images/placeholders/placeholder485x560.png'
import Image from 'next/image'
import { FC } from 'react'

import OverflowImage from '@/components/OverflowImage'
import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'

const PayhawkSolution: FC<{}> = () => {
    const { smScreen } = useDevice()

    return (
        <Box
            sx={{
                position: 'relative',
            }}
        >
            <TwoColumnLayout
                leftCol={5}
                rightCol={6}
                columnWrapOrderOnMobile={ColumnWrapOrder.REVERSE}
            >
                <OverflowImage
                    float={`right`}
                    containerSx={{
                        ...(smScreen
                            ? {
                                  height: '400px !important',
                              }
                            : {}),
                    }}
                    placeholder={
                        <Image
                            width={485}
                            height={560}
                            src={PlaceHolder}
                            alt={'placeholder'}
                            style={{
                                opacity: 0,
                                ...(smScreen
                                    ? {
                                          height: '400px',
                                      }
                                    : {}),
                            }}
                        />
                    }
                >
                    <Image
                        width={860}
                        height={560}
                        src={PayhawkSolutionImg}
                        alt={'Payhawk Green'}
                        style={{
                            ...(smScreen
                                ? {
                                      height: '100%',
                                      objectFit: 'scale-down',
                                      objectPosition: 'right',
                                  }
                                : {}),
                        }}
                    />
                </OverflowImage>
                <TitleAndParagraph
                    title={`Solution: Payhawk Green`}
                    paragraph={
                        <span>
                            Having integrated Lune’s API, Payhawk now automatically calculates the
                            CO₂e emissions of every card purchase.
                            <br />
                            <br />
                            By partnering with Lune, Payhawk unlocked quality calculations anchored
                            in the GHG Protocol. Calculations that were report-ready for corporate
                            accounting, and decision-useful for pinpointing decarbonisation
                            opportunities. With driving climate action being key, Payhawk could also
                            add high quality carbon removal to its roadmap with Lune’s end-to-end
                            API integration.
                            <br />
                            <br />
                            In just two weeks, Payhawk had plugged into Lune’s API. It was quick and
                            seamless. And just like that, they were ready to start winning deals.
                        </span>
                    }
                />
            </TwoColumnLayout>
        </Box>
    )
}

export default PayhawkSolution
